export default __webpack_public_path__ + "static/media/GUILD.32f0b6dd.png";